import { useEffect, useState } from 'react';

import { selectCustomer } from '@jane/monolith/customer/redux/customer';
import { useCustomerSelector } from '@jane/monolith/customer/selectors';
import { LogInModal } from '@jane/shared-ecomm/components';
import { useAuthentication } from '@jane/shared-ecomm/providers';

export const LoginModal = () => {
  const { authenticated: isLoggedIn } = useCustomerSelector(selectCustomer);
  const { defaultLogin, register, resetPassword, ...authProps } =
    useAuthentication();
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    if (!isLoggedIn) {
      setShowLoginModal(true);
    } else {
      setShowLoginModal(false);
    }
  }, [isLoggedIn]);

  return (
    <LogInModal
      {...authProps}
      location="header"
      onSignInSubmit={defaultLogin}
      onCreateAccountSubmit={register}
      onForgotPasswordSubmit={resetPassword}
      open={showLoginModal}
      onRequestClose={() => setShowLoginModal(false)}
    />
  );
};
